import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BreadCrumb from '@app/components/common/BreadCrumb';
import { isExternalReferrer } from '@app/utils';
import PropTypes from 'prop-types';
import Espot from '../../../common/Espot/Espot';
import { ESPOT_VARIANTS } from '@app/constants/commonConstants';
import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';
import { getUpdatedBreadcrumbs } from '@app/components/common/BreadCrumb/utils';

const ProductListHeader = ({ espotData }) => {
  const [t] = useTranslation();
  const currentCategory = useSelector(state => state.plpUI.current);
  const breadcrumbLinks =
    useSelector(s => s.categories.byId[currentCategory]?.breadCrumbs) || [];
  const subCategoryTitle = useSelector(
    s => s.categories.byId[currentCategory]?.name
  );
  const shopByCategoryUrl = useSelector(s => s.categories.shopByCategory);
  const showBackButton = !isExternalReferrer(
    document.referrer,
    document.location.host
  );
  const allCategoriesLink = {
    label: startCase(toLower(t('SEARCH_ALL_DEPARTMENTS'))),
    value: shopByCategoryUrl
  };
  const updatedBreadCrumbs = getUpdatedBreadcrumbs(
    breadcrumbLinks,
    allCategoriesLink
  );

  return (
    <>
      {updatedBreadCrumbs && (
        <BreadCrumb
          links={updatedBreadCrumbs}
          backButtonText={t('UC_BACK')}
          showBackButton={showBackButton}
        />
      )}
      {espotData && (
        <Espot html={espotData} variant={ESPOT_VARIANTS.PINSTRIPE} />
      )}
      <header className="mb-3 mb-md-2 mt-4">
        <h1 className="display-1 h1">{subCategoryTitle}</h1>
      </header>
    </>
  );
};
ProductListHeader.propTypes = {
  espotData: PropTypes.arrayOf(PropTypes.string)
};
export default ProductListHeader;
